export const VOICE_MODE_STATES = { IDLE: 'idle', CONNECTING: 'connecting', RESUMING: 'resuming', LISTENING: 'listening', PROCESSING: 'processing', SPEAKING: 'speaking', ERROR: 'error' };
